import {translations} from 'presentation/translations-new';
import {textHandle} from 'presentation/utils/textHandle';
import React from 'react';
import {DataContentCard} from '../../../../components/DataContentCard';
import {StyledCard, StyledDataContent, StyledHeaderContainer, StyledTitle} from './styles';
import {ProceduresCardType} from './types';

const {doctor, requestDate, session} =
	translations['pt-br'].privateFlow.myHospitalization.procedures.card;

export const ProceduresCard = ({procedure, dataTestId}: ProceduresCardType) => (
	<StyledCard data-test-id={dataTestId}>
		<StyledHeaderContainer>
			<StyledTitle variant="h6">{procedure.procedureName}</StyledTitle>
		</StyledHeaderContainer>
		<StyledDataContent>
			<DataContentCard
				iconName="stethoscope"
				title={doctor}
				description={textHandle(procedure.requestingDoctorName.toLowerCase()).capitalize()}
			/>
			<DataContentCard
				iconName="query-builder-filled"
				title={requestDate}
				description={`${procedure.prescriptionDate} às ${procedure.prescriptionTime}`}
			/>
			<DataContentCard
				iconName="assignment-default"
				title={session}
				description={procedure.procedureQuantity.toLocaleString('pt-BR', {
					minimumIntegerDigits: 2,
				})}
			/>
		</StyledDataContent>
	</StyledCard>
);
